import React from 'react';
import './CardSesDomination.scss';
import { Col, Row } from 'antd';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { BaseCard } from '../BaseCard';
import ReactDomServer from 'react-dom/server';
import _ from 'lodash';
import { generateUUID } from '@bvt-utils';

/**
 * @author Randa<m.randa@bvarta.com>
 * @author Renta<enta.yustika@bvarta.com>
 * @copyright PT Bhumi Varta Tecnology
 * @param {Object} props
 * @param {Array<{label: string, value: number,color: string}>} props.data
 * @param {boolean} props.isLoading
 * @param {boolean} props.isShowPie
 */
export const CardSesDomination = (props) => {
  const { data = [], isLoading, isShowPie = true, style } = props;
  const totalData = _.sumBy(data, (v) => v.value) || 100;

  /**
   * @type {(par:number)=>void}
   */
  const getPercentage = (par) => (((par / totalData) || 0) * 100)?.toFixed(2);

  const maxSes = _.maxBy(data, (v) => v?.value);

  /**
   * @type {(Highcharts.Options)}React.rende
   */
  const chartOptions = {
    credits: {
      enabled: false,
    },
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: 0,
      plotShadow: false,
      height: 212,
      spacingTop: 0,
      spacingLeft: 0,
      spacingRight: 0,
      spacingBottom: 0,
    },
    title: {
      text: ReactDomServer.renderToString(
        <div className='CardSesDomination__chart-pie-title'>
          <div>SES Domination</div>
          <b>{maxSes?.label}</b>
          <div>
            <b>{getPercentage(maxSes?.value)}%</b>
          </div>
        </div>
      ),
      useHTML: true,
      align: 'center',
      verticalAlign: 'middle',
      y: 20,
    },
    tooltip: {
      useHTML: true,
      pointFormat: '<b>{point.percentage:.1f}%</b>',
      borderColor: 'transparent',
      shadow: {
        color: '#000',
        offsetX: 0,
        offsetY: 0.1,
        opacity: 0.2,
        width: 2,
      },
      backgroundColor: '#fff',
      borderRadius: 8,
      headerFormat: ' ',
    },
    accessibility: {
      enabled: false,
      point: {
        valueSuffix: '%',
      },
    },
    plotOptions: {
      pie: {
        dataLabels: {
          enabled: false,
        },
      },
    },
    series: [
      {
        type: 'pie',
        name: 'SES',
        innerSize: '85%',
        states: {
          inactive: {
            opacity: 1,
          },
          hover: {
            shadow: false,
            halo: {
              enabled: false,
              opacity: 0,
            },
          },
        },
        data: data?.map((v) => ({
          y: v?.value,
          name: v?.label,
          color: v?.color,
        })),
      },
    ],
  };
  return (
    <div className='shared CardSesDomination' style={style}>
      <BaseCard
        isLoading={isLoading}
        title='Social Economic Status (SES)'
        withPadding={true}
      >
        <Row align='middle'>
          {isShowPie && (
            <Col xs={8}>
              {data?.length > 0 && (
                <HighchartsReact
                  allowChartUpdate={true}
                  highcharts={Highcharts}
                  options={{ ...chartOptions }}
                />
              )}
            </Col>
          )}
          <Col xs={isShowPie ? 16 : 24}>
            <div className='CardSesDomination__bar-wrapper'>
              {data?.map((item) => (
                <div className='CardSesDomination__bar-outer' key={generateUUID()}>
                  <div className='CardSesDomination__bar-text'>
                    <span>{item?.label}</span>
                  </div>
                  <div className='CardSesDomination__bar-number'>
                    <span>({getPercentage(item?.value)} %)</span>
                  </div>
                  <div
                    className='CardSesDomination__bar-bar'
                    style={{
                      width: getPercentage(item?.value) + '%',
                      background: item?.color,
                    }}
                  />
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </BaseCard>
    </div>
  );
};
CardSesDomination.displayName = 'CardSesDomination';
